"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.learningComponentHeaderConfig = exports.LearningComponentHeaderCellEnum = void 0;
var LearningComponentHeaderCellEnum;
(function (LearningComponentHeaderCellEnum) {
    LearningComponentHeaderCellEnum["Type"] = "type";
    LearningComponentHeaderCellEnum["Name"] = "name";
    LearningComponentHeaderCellEnum["LearningType"] = "learningType";
    LearningComponentHeaderCellEnum["Language"] = "language";
    LearningComponentHeaderCellEnum["Duration"] = "duration";
})(LearningComponentHeaderCellEnum || (exports.LearningComponentHeaderCellEnum = LearningComponentHeaderCellEnum = {}));
exports.learningComponentHeaderConfig = [
    {
        name: LearningComponentHeaderCellEnum.Type,
        label: 'typeLabel',
        filterable: true,
        sortable: false,
        searchable: false,
    },
    {
        name: LearningComponentHeaderCellEnum.Name,
        label: 'nameLabel',
        filterable: false,
        sortable: false,
        searchable: true,
    },
    {
        name: LearningComponentHeaderCellEnum.LearningType,
        label: 'learningTypeLabel',
        filterable: true,
        sortable: false,
        searchable: false,
    },
    {
        name: LearningComponentHeaderCellEnum.Language,
        label: 'languagesLabel',
        filterable: true,
        sortable: false,
        searchable: false,
    },
    {
        name: LearningComponentHeaderCellEnum.Duration,
        label: 'durationLabel',
        filterable: false,
        sortable: false,
        searchable: false,
    },
];
